export const NAME = "public/signIn";
